import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import closeIcon from '../static/img/SelectGame/iconCloseButton.svg';
import styles from '../static/styles/DailyTasks.module.css';
import RewardClaimPopup from '../components/RewardClaimPopup';
import todayTaskImage from '../static/img/DailyCheckin/imageTodayTask.avif';
import lockIcon from '../static/img/DailyCheckin/iconLock.svg';
import { fetchGameChallenges } from '../api/games';
import SelectGame from './SelectGame';

import DailyTaskItem from '../components/DailyTaskItem';
import TaskImageUploadPopup from '../components/TaskImageUploadPopup';
import { isAuthenticated } from '../api/auth';

const DailyTasks = () => {
  const [activeDay, setActiveDay] = useState(null);
  const [rewardClaimed, setRewardClaimed] = useState(false);
  const [showRewardPopup, setShowRewardPopup] = useState(false);
  const [activeDayData, setActiveDayData] = useState(null);
  const [showGameSelect, setShowGameSelect] = useState(false);
  const [challengeData, setChallengeData] = useState();
  const [showTaskPopup, setShowTaskPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Daily Task | Jazz Esl";
    if (!isAuthenticated()) {
      window.location.href = process.env.REACT_APP_LOGIN_URL;
      return;
    }

    try {
      const storedActiveDayData = localStorage.getItem('activeDayData');
      if (storedActiveDayData) {
        const parsedData = JSON.parse(storedActiveDayData);
        setActiveDayData(parsedData);

        if (!parsedData.gameId) {
          // console.log("No game ID found, showing game selector");
          setShowGameSelect(true);
        } else {
          fetchDailyTasks(parsedData.gameId);
        }
      } else {
        // console.log("No active day data found, showing game selector");
        setShowGameSelect(true);
      }
    } catch (error) {
      // console.error("Error parsing activeDayData:", error);
      setShowGameSelect(true);
    }

    setIsLoading(false);
  }, []);

  const fetchDailyTasks = async (gameId) => {
    try {
      // console.log("Fetching game challenges for gameId:", gameId);
      const gameChallenges = await fetchGameChallenges(gameId);
      if (gameChallenges.success && gameChallenges.data && gameChallenges.data.length > 0) {
        setChallengeData(gameChallenges.data[0]);
      } else {
        // console.error("No challenge data received or empty data array");
      }
    } catch (error) {
      // console.error('Error fetching game challenges:', error);
    }
  };

  const handleTaskSubmit = () => {
    if (challengeData && challengeData.entryStatus === "Not submitted")
      setShowTaskPopup(true);
  };

  const handleClose = () => {
    navigate('/');
  };

  const handleCloseRewardPopup = () => {
    setShowRewardPopup(false);
  };

  const handleGameSelectClose = () => {
    setShowGameSelect(false);
    const storedActiveDayData = localStorage.getItem('activeDayData');
    const parsedData = JSON.parse(storedActiveDayData);
    const wasGameSelected = parsedData.gameId;
    if (wasGameSelected === null) {
      // console.log("ASD")
      navigate('/');
    } else {
      window.location.reload();
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {challengeData ? (
        challengeData.archieved === 1 ? (
          <div className={styles.dailyCheckinContainer}>
            <div className={styles.dailyCheckinOverlay}>
              <p>No challenges available for today</p>
            </div>
          </div>
        ) : (
          <div className={styles.dailyCheckinContainer}>
            <div className={styles.dailyCheckinOverlay}>
              <img
                src={closeIcon}
                alt="Close"
                className={styles.closeButton}
                onClick={handleClose}
              />

              <div className={styles.rewardsHeader}>
                <img src={todayTaskImage} alt="Welcome" className={styles.welcomeImage} />
              </div>

              {challengeData.entryStatus != "Not submitted" && <h4 className={styles.taskCompletionMessage}>
                Great<br />You've completed today's task<br />Come back tomorrow for a new one!
              </h4>}


              <div style={{ display: 'flex', width: '100%', justifyContent: "space-between", gap: '20px' }}>
                <div style={{ width: '25%', alignSelf: 'center' }}>
                  {activeDayData && (activeDayData.streak_to_claim - 1) > 0 &&
                    <DailyTaskItem
                      day={activeDayData.streak_to_claim - 1}
                      activeDay={activeDayData.streak_to_claim}
                      rewardAmount={activeDayData.amount_to_claim - 5}
                    />
                  }
                </div>
                <div style={{ width: '50%' }} onClick={handleTaskSubmit}>
                  {activeDayData &&
                    <DailyTaskItem
                      taskImage={challengeData.challenge_thumbnail}
                      day={activeDayData.streak_to_claim}
                      activeDay={activeDayData.streak_to_claim}
                      rewardAmount={activeDayData.amount_to_claim}
                    />
                  }
                </div>
                <div style={{ width: '25%', alignSelf: 'center' }}>
                  {activeDayData &&
                    <DailyTaskItem
                      day={activeDayData.streak_to_claim + 1}
                      activeDay={activeDayData.streak_to_claim}
                      rewardAmount={activeDayData.amount_to_claim + 5}
                    />
                  }
                </div>
              </div>
              <p>{challengeData.name} <br /> Win {challengeData.prize} Credits </p>
              <div className={styles.claimBtnHeader}>
                <button
                  className={styles.claimBtn}
                  onClick={handleTaskSubmit}
                  disabled={challengeData.entryStatus !== "Not submitted"}
                >
                  <span>
                    {challengeData.entryStatus === "Not submitted" ? "Submit Entry" : "Submitted"}
                  </span>
                </button>
              </div>
            </div>

            {showTaskPopup &&
              <TaskImageUploadPopup
                isOpen={showTaskPopup}
                onClose={() => { setShowTaskPopup(false); window.location.reload() }}
                taskImage={challengeData.challenge_thumbnail}
                challengeId={challengeData.challengeId}
              />
            }

            <RewardClaimPopup
              isOpen={showRewardPopup}
              onClose={handleCloseRewardPopup}
              credits={15}
            />
          </div>
        )
      ) : (
        <div className={styles.dailyCheckinContainer}>
          <div className={styles.dailyCheckinOverlay}>
            <p>Loading daily tasks...</p>
          </div>
        </div>
      )}

      <SelectGame
        isOpen={showGameSelect}
        onClose={handleGameSelectClose}
      />
    </>
  );
};

export default DailyTasks;